/**
 * Poses set by hand in the studio's pose workshop (ท่าทาง). Written by the studio's
 * "บันทึกเข้าระบบ" button through the dev server: edit there rather than by hand.
 */
import type { PoseEdit } from './skeleton';

export const SAVED_POSES: readonly PoseEdit[] = [];
